<template>
  <div class="avantages">
    <div>
      <div
        v-if="!authenticated"
        class="signin-section"
      >
        <div class="background-image">
          <img
            src="~/assets/img/signin-bg.png"
            loading="lazy"
          />
        </div>
        <div class="inner-section">
          <div class="infos-container">
            <div class="title-bloc">
              <div class="title-bloc_text">
                <h1>
                  Rejoignez <br />la communauté <br />
                  <b v-html="crossContent?.benefitsPage.title" />
                </h1>
                <ButtonSimple
                  class="title-bloc_btn"
                  label="S'inscrire"
                  color="white"
                  @click="scrollToSignIn"
                />
              </div>
              <div
                v-if="crossContent?.benefitsPage.desktop_image"
                class="title-bloc_img"
              >
                <div v-if="isMobile || isLargeMobile || isTabletPortrait">
                  <img
                    :src="
                      crossContent.benefitsPage.mobile_image
                        ? crossContent.benefitsPage.mobile_image.url
                        : crossContent.benefitsPage.desktop_image.url
                    "
                    :alt="crossContent.benefitsPage.title"
                    loading="lazy"
                  />
                </div>
                <div v-else>
                  <img
                    :src="crossContent.benefitsPage.desktop_image.url"
                    :alt="crossContent.benefitsPage.title"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
            <hr />
            <h2>{{ crossContent?.benefitsPage.title2 }}</h2>
            <div class="enrollment-bloc">
              <div class="enrollment-bloc_text">
                <p v-html="crossContent?.benefitsPage.content" />
                <NuxtLink
                  v-if="crossContent?.benefitsPage.page_legal"
                  :to="`/page/${crossContent.benefitsPage.page_legal.slug}`"
                  class="link"
                >
                  {{ crossContent.benefitsPage.label_page_legal }}
                </NuxtLink>
              </div>
              <div
                v-if="crossContent?.benefitsPage.desktop_image2"
                class="enrollment-bloc_img"
              >
                <div
                  v-if="
                    isMobile ||
                    isLargeMobile ||
                    isTabletPortrait ||
                    isSmallScreen
                  "
                >
                  <img
                    :src="
                      crossContent.benefitsPage.mobile_image2
                        ? crossContent.benefitsPage.mobile_image2.url
                        : crossContent.benefitsPage.desktop_image2.url
                    "
                    :alt="crossContent.benefitsPage.title2"
                    loading="lazy"
                  />
                </div>
                <div v-else>
                  <img
                    :src="crossContent.benefitsPage.desktop_image2.url"
                    :alt="crossContent.benefitsPage.title2"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            ref="signin"
            class="form-container"
          >
            <RegisterForm :referrer="referrer" />
          </div>
        </div>
      </div>
      <div class="header-section">
        <img
          :src="currentPageInfo.image"
          class="background-image"
          loading="lazy"
        />
        <div class="layer" />
        <h2 v-html="currentPageInfo.titleBig" />
        <p
          class="subtitle"
          v-html="currentPageInfo.description"
        />
      </div>
      <div class="content">
        <div class="step step1">
          <div class="inner-step">
            <div class="timeline">
              <div class="number">1</div>
              <div class="line" />
            </div>
            <div class="step-content">
              <img
                src="~/assets/img/cups.png"
                alt="coupes"
                class="step-img"
                loading="lazy"
              />
              <div class="text">
                <h2>
                  PRENEZ LA TÊTE<br />
                  DU CLASSEMENT MENSUEL
                </h2>
                <p>
                  Plus vous êtes actif sur le site, plus vous cumulez de points.
                  <br />Chaque mois, échangez avec la communauté, postez du
                  contenu, partagez vos astuces, donnez votre avis, et remportez
                  nos challenges in-game pour atteindre le top du classement!
                  Les participations reconnues comme les plus pertinentes par la
                  communauté seront mises en avant et permettront d’accéder à
                  des badges Gold.<br /><br />

                  Retrouvez toutes les actions récompensées dans la section «
                  <span>Mes badges</span> » de votre profil.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="step step2 blue">
          <div class="inner-step">
            <div class="timeline">
              <div class="number">2</div>
              <div class="line" />
            </div>
            <div class="step-content">
              <div class="text">
                <h2>
                  REMPORTEZ DES BONS<br />
                  D’ACHATS
                </h2>
                <p>
                  Tout au long du mois, cumulez vos points et confrontez-vous
                  aux autres Wapers dans le classement mensuel. À la fin du
                  mois, en fonction de votre classement, vous pouvez remporter
                  des bons d’achat d’une valeur de 15€, 10€, ou 5€ valables sur
                  le PlayStation Store. Chaque mois, les compteurs de points
                  sont remis à zéro.
                </p>
              </div>
              <img
                src="~/assets/img/login-gift.png"
                alt="PlayStation Store"
                class="step-img mini"
                loading="lazy"
              />
              <img
                src="~/assets/img/login-gift@2x.png"
                alt="PlayStation Store"
                class="step-img not-mini"
                loading="lazy"
              />
            </div>
          </div>
        </div>
        <div class="step step3">
          <div class="inner-step">
            <div class="timeline">
              <div class="number">3</div>
              <div class="line" />
            </div>
            <div class="step-content">
              <img
                src="~/assets/img/step3mini.png"
                alt="badges"
                class="step-img mini"
                loading="lazy"
              />
              <img
                src="~/assets/img/step3.png"
                alt="badges"
                class="step-img not-mini"
                loading="lazy"
              />
              <div class="text">
                <h2>
                  DEVENEZ COLLECTIONNEUR<br />
                  DE BADGES
                </h2>
                <p>
                  En fonction de vos actions sur la plateforme, vous débloquez
                  automatiquement des badges que vous pouvez retrouver sur votre
                  profil. Les badges récompensent votre implication et vous font
                  progresser sur le classement général, mais surtout, ils vous
                  permettent de valoriser votre profil: vous pouvez par exemple
                  choisir le badge que vous arborez sur votre avatar afin de
                  vous distinguer au sein de la communauté.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="step step4 blue">
          <div class="inner-step">
            <div class="timeline">
              <div class="number">4</div>
              <div class="line" />
            </div>
            <div class="step-content">
              <img
                src="~/assets/img/step4mini.png"
                alt="fortnite"
                class="step-img mini"
                loading="lazy"
              />
              <img
                src="~/assets/img/step4.png"
                alt="fortnite"
                class="step-img not-mini"
                loading="lazy"
              />
              <div class="text">
                <h2>
                  DEVENEZ UN VERY<br />
                  IMPORTANT PLAYER
                </h2>
                <p>
                  Découvrez les coulisses de l’univers PlayStation grâce à votre
                  contribution au sein de la communauté ! Accédez à des
                  évènements gaming exclusifs et profitez des dernières
                  nouveautés…<br />
                  et ça, que vous soyez de Paris ou de Province !
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!authenticated"
          class="cta"
        >
          <h2>rejoignez la communauté We Are PlayStation dès maintenant !</h2>
          <ButtonSimple
            label="S'inscrire"
            @click="scrollToSignIn"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
useHead({
  title: `Principes et règles de fonctionnement de We Are PlayStation`,
})

useSeoMeta({
  title: `Principes et règles de fonctionnement de We Are PlayStation`,
  description: `Sur We Are PlayStation, toute votre activité au sein de la communauté est récompensée et vous permet de collecter des points et des badges pour bénéficier d’avantages et de bons plans.`,
  ogTitle: `Rejoignez la communauté We Are PlayStation`,
  ogDescription: `Sur We Are PlayStation, votre activité au sein de la communauté vous permet de collecter des points et des badges pour bénéficier d’avantages et de bons plans.`,
  ogImage: 'https://www.weareplaystation.fr/img/comment_ca_marche.jpg',
})

const crossContentStore = useCrossContentStore()

const { crossContent, referrer } = storeToRefs(crossContentStore)

const { isMobile, isLargeMobile, isTabletPortrait, isSmallScreen } =
  useCustomMediaQuery()

const signin = ref<HTMLElement | null>(null)

const { authenticated } = useAuthenticated()

const currentPageInfo = {
  titleBig: 'TOUS LES AVANTAGES<br>WE ARE PLAYSTATION ',
  image: '/img/comment_ca_marche.jpg',
  description:
    'Sur We Are PlayStation, toute votre activité au sein de la communauté est récompensée.<br>L’ensemble de vos contributions sur la plateforme vous permet de collecter des points et des badges pour bénéficier d’avantages et de bons plans.',
}

const { gtag } = useGtag()

const scrollToSignIn = () => {
  const signinBounding = useElementBounding(signin)

  window.scrollTo({
    top: signinBounding.top.value + window.scrollY - 90,
    behavior: 'smooth',
  })

  gtag('event', 'clicinscription', {
    cta_name: "bas_S'inscrire",
  })
}
</script>

<style lang="scss" scoped>
.avantages {
  .signin-section {
    position: relative;
    background: #eee;

    .background-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 612px;
      pointer-events: none;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top left;
      }

      &::after {
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 2;
        width: 0;
        height: 0;
        border-width: 0 0 5rem 100vw;
        border-style: solid;
        border-color: transparent transparent #eee;
      }
    }

    .inner-section {
      position: relative;
      z-index: 2;
      display: flex;
      justify-content: space-between;
      max-width: 1600px;
      margin: 0 auto;
      padding: 70px 80px 90px;

      @media screen and (max-width: 1280px) {
        flex-direction: column;
      }

      @media screen and (max-width: 992px) {
        padding: 0;
      }

      .form-container {
        scroll-margin-top: 70px;
        flex-shrink: 0;
        width: 568px;
        padding: 40px 50px 55px;
        background: #fff;

        @media screen and (max-width: 1280px) {
          width: 100%;
          margin-top: 80px;
        }

        @media screen and (max-width: 550px) {
          margin-top: 40px;
        }

        @media screen and (max-width: 375px) {
          padding: 20px 15px 25px;
        }
      }

      .infos-container {
        width: calc(100% - 568px);

        @media screen and (max-width: 1280px) {
          width: 100%;
        }

        @media screen and (max-width: 992px) {
          padding: 40px;
        }

        .title-bloc {
          display: flex;
          justify-content: space-between;
          padding-top: 80px;
          padding-right: 80px;

          @media screen and (max-width: 1600px) {
            flex-direction: column;
            align-items: center;
            padding-top: 40px;
          }

          @media screen and (max-width: 1280px) {
            flex-direction: row;
            align-items: flex-start;
          }

          @media screen and (max-width: 992px) {
            flex-direction: column;
            align-items: center;
            padding-right: 0;
          }

          h1 {
            flex-shrink: 0;
            width: 377px;
            color: #fff;
            font-family: SST;
            font-size: 42px;
            font-weight: 300;
            line-height: 52px;
            letter-spacing: 0;

            b {
              font-weight: 800;
            }

            @media screen and (max-width: 1600px) {
              width: 100%;
            }

            @media screen and (max-width: 1280px) {
              width: 388px;
            }

            @media screen and (max-width: 992px) {
              width: 100%;
            }

            @media screen and (max-width: 550px) {
              font-size: 24px;
              line-height: 34px;
            }
          }

          &_img {
            width: 392px;
            max-width: 100%;
            padding-top: 15px;

            img {
              width: 100%;
            }

            @media screen and (max-width: 1600px) {
              width: 500px;
              padding-top: 30px;
            }

            @media screen and (max-width: 1280px) {
              padding-top: 60px;
            }

            @media screen and (max-width: 992px) {
              padding-top: 30px;
            }
          }

          &_btn {
            margin-top: 40px;

            @media screen and (min-width: 1280px) {
              display: none;
            }
          }
        }

        hr {
          margin-top: 110px;
          margin-right: 80px;
          margin-bottom: 80px;
          opacity: 0.3;

          @media screen and (max-width: 1600px) {
            margin-top: 60px;
            margin-bottom: 60px;
          }

          @media screen and (max-width: 1280px) {
            margin-right: 0;
          }
        }

        h2 {
          margin-bottom: 70px;
          padding-right: 210px;

          @media screen and (max-width: 1600px) {
            margin-bottom: 40px;
            padding-right: 80px;
          }

          @media screen and (max-width: 1280px) {
            max-width: 657px;
          }

          @media screen and (max-width: 992px) {
            min-width: 100%;
            margin-bottom: 40px;
            padding-right: 0;
          }

          @media screen and (max-width: 550px) {
            font-size: 20px;
            line-height: 1.4;
          }
        }

        .enrollment-bloc {
          display: flex;
          justify-content: space-between;
          align-items: center;

          @media screen and (max-width: 1600px) {
            flex-direction: column;
          }

          @media screen and (max-width: 1280px) {
            flex-direction: row;
          }

          @media screen and (max-width: 992px) {
            flex-direction: column;
          }

          &_text {
            flex-shrink: 0;
            width: 345px;
            margin-right: 20px;

            p {
              font-size: 20px;
              line-height: 1.4;

              @media screen and (max-width: 992px) {
                font-size: 18px;
                line-height: 1.4;
              }
            }

            .link {
              display: block;
              margin-top: 40px;
              color: $blue;

              @media screen and (max-width: 992px) {
                font-size: 18px;
                line-height: 1.4;
              }
            }

            @media screen and (max-width: 1600px) {
              width: 100%;
              margin-right: 0;
              margin-bottom: 40px;
              padding-right: 80px;
            }

            @media screen and (max-width: 1280px) {
              width: 55%;
              padding-right: 45px;
            }

            @media screen and (max-width: 992px) {
              width: 100%;
              margin-right: 0;
              margin-bottom: 40px;
              padding-right: 0;
            }

            @media screen and (max-width: 550px) {
              margin-right: 0;
              padding-right: 0;
            }
          }

          &_img {
            max-width: 480px;
            padding-right: 80px;

            img {
              width: 100%;
            }

            @media screen and (max-width: 1600px) {
              padding-right: 40px;
            }

            @media screen and (max-width: 1280px) {
              width: 45%;
              padding-right: 0;
            }

            @media screen and (max-width: 992px) {
              width: 100%;
              max-width: 480px;
              padding-right: 0;
            }

            @media screen and (max-width: 701px) {
              max-width: 100%;
            }
          }
        }
      }
    }
  }

  .content {
    .step {
      width: 100%;
      height: 54.8rem;

      &.blue {
        color: $white;
        background: #0f6eba;

        .inner-step {
          .timeline {
            .number {
              color: initial;
              border-color: #62b0fa;
            }

            .line {
              background: #62b0fa;
            }
          }
        }
      }

      .inner-step {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        max-width: 160rem;
        height: 100%;
        margin: auto;

        .step-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: calc(100% - 8.2rem - 4.8rem - 7.2rem);
          height: 100%;
        }

        .text {
          width: 57.3rem;
          margin-right: 9.8rem;

          h2 {
            margin-bottom: 4rem;
            font-size: 3.4rem;
            font-weight: 500;
            line-height: 4.9rem;
            letter-spacing: 0.5rem;
          }

          p {
            font-size: 1.4rem;
            line-height: 2.4rem;
          }
        }

        .timeline {
          position: relative;
          height: 100%;
          margin-right: 4.8rem;
          margin-left: 8.2rem;

          .number {
            position: relative;
            z-index: 1;
            width: 7.2rem;
            height: 7.2rem;
            margin-top: 9.8rem;
            font-size: 2.6rem;
            line-height: 7rem;
            text-align: center;
            background: $white;
            border: 3px solid #e2e2e2;
            border-radius: 3.6rem;
          }

          .line {
            position: absolute;
            top: 0;
            left: 50%;
            width: 1px;
            height: 100%;
            background: #e2e2e2;
            transform: translateX(-50%);
          }
        }
      }

      @media screen and (max-width: 1024px) {
        height: auto;

        .inner-step {
          align-items: flex-start;

          .timeline {
            align-self: stretch;
            height: 100%;
            height: auto;

            .number {
              margin-top: 5rem;
            }

            .line {
              top: 0;
              height: 100%;
            }
          }

          .step-content {
            flex-direction: column-reverse;
            justify-content: flex-end;
            align-items: flex-start;
            margin-top: 5rem;
            margin-bottom: 3rem;
            padding-right: 8rem;

            .text {
              width: 100%;
              max-width: 57.3rem;
              margin-right: 0;
            }

            .step-img {
              width: 100%;
              max-width: 53.1rem;
              margin-top: 2rem;
              margin-bottom: 2rem;
            }
          }
        }
      }

      @media screen and (max-width: 700px) {
        .inner-step {
          .timeline {
            margin-right: 2.4rem;
            margin-left: 2.1rem;

            .number {
              width: 4.6rem;
              height: 4.6rem;
              font-size: 1.6rem;
              line-height: 4.2rem;
            }
          }

          .step-content {
            flex-grow: 1;
            padding-right: 2.5rem;

            .text {
              margin-left: 0;

              h2 {
                font-size: 2rem;
                font-weight: 400;
                line-height: 2.7rem;
                letter-spacing: 0.2rem;
              }
            }

            .step-img {
              width: 100%;
              max-width: 53.1rem;
              margin-top: 2rem;
              margin-bottom: 2rem;
            }
          }
        }
      }

      &.step1 {
        .inner-step {
          .step-img {
            width: calc(100% - 70rem);
            max-width: 53.1rem;
          }

          .timeline {
            .line {
              top: 10rem;
              height: calc(100% - 10rem);
            }
          }

          .text {
            flex-shrink: 0;
            margin-left: 2rem;

            span {
              color: $blue;
            }
          }
        }

        @media screen and (max-width: 1024px) {
          .inner-step {
            padding: 5rem 0 0;

            .timeline {
              .number {
                margin-top: 0;
              }

              .line {
                top: 0;
                height: 100%;
              }
            }

            .step-content {
              flex-direction: column-reverse;
              justify-content: flex-end;
              align-items: flex-start;
              margin-top: 0;
              padding-right: 8rem;

              .text {
                width: 100%;
                max-width: 57.3rem;
                margin-left: 0;
              }

              .step-img {
                width: 100%;
                max-width: 53.1rem;
                margin-top: 2rem;
                margin-bottom: 2rem;
              }
            }
          }
        }

        @media screen and (max-width: 700px) {
          .inner-step {
            .step-content {
              padding-right: 2.4rem;

              .step-img {
                width: 100%;
                max-width: 53.1rem;
                margin-top: 2rem;
              }
            }
          }
        }
      }

      &.step2 {
        overflow: hidden;
        background: url('~/assets/img/step2bg.jpg');
        background-position: bottom left;
        background-size: cover;

        .inner-step {
          position: relative;
          justify-content: flex-start;
          max-width: 160rem;
          padding-right: 10rem;

          .step-content {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .mini {
            display: none;
          }

          .not-mini {
            width: auto;
            max-width: 595px;
            height: 80%;
            object-fit: contain;
          }

          .text {
            flex-shrink: 0;
            width: 46.7rem;
            margin-right: 2rem;
          }
        }

        @media screen and (max-width: 1280px) {
          .inner-step {
            padding-right: 70rem;
          }
        }

        @media screen and (max-width: 1024px) {
          .inner-step {
            padding-right: 0;
            overflow: hidden;

            .step-content {
              position: relative;
              flex-direction: column;

              .text {
                width: 100%;
                max-width: 100%;

                // padding-bottom: 66.6vw;
              }

              .mini {
                display: block;
              }

              .not-mini {
                display: none;
              }

              .step-img {
                width: 100%;
              }
            }
          }
        }
      }

      &.step3 {
        overflow: hidden;

        .inner-step {
          .timeline {
            .number {
              z-index: 2;
            }

            .line {
              z-index: 1;
            }
          }

          .step-content {
            position: relative;
            justify-content: flex-end;
          }

          .text {
            z-index: 1;
            padding-right: 7.2rem;
          }

          .mini {
            display: none;
          }

          .not-mini {
            position: absolute;
            top: 0;
            right: 0;
            z-index: 0;
            width: auto;
            height: 100%;
          }
        }

        @media screen and (max-width: 1024px) {
          .inner-step {
            overflow: hidden;

            .step-content {
              .text {
                width: 100%;
                max-width: 100%;
                padding-right: 0;
                padding-bottom: 70vw;
              }

              .mini {
                display: block;
              }

              .not-mini {
                display: none;
              }

              .step-img {
                position: absolute;
                bottom: 0;
                left: calc(-8.2rem - 4.8rem - 7.2rem);
                width: 105vw;
                max-width: 105vw;
              }
            }
          }
        }

        @media screen and (max-width: 700px) {
          .inner-step {
            overflow: hidden;

            .step-content {
              .step-img {
                left: calc(-2.1rem - 2.4rem - 4.6rem);
              }
            }
          }
        }
      }

      &.step4 {
        overflow: hidden;
        background: rgb(15 110 186);
        background: linear-gradient(
          90deg,
          rgb(15 110 186 / 1) 48%,
          rgb(104 206 244 / 1) 49%
        );

        .inner-step {
          position: relative;
          justify-content: flex-start;
          background: rgb(15 110 186);

          .timeline {
            .number {
              z-index: 2;
            }

            .line {
              z-index: 1;
            }
          }

          .step-content {
            position: relative;
          }

          .text {
            z-index: 1;
            width: 46.7rem;
          }

          .mini {
            display: none;
          }

          .not-mini {
            position: absolute;
            top: 0;
            left: 50rem;
            z-index: 0;
            width: auto;
            height: 100%;
          }
        }

        @media screen and (max-width: 1024px) {
          .inner-step {
            .step-content {
              .text {
                width: 100%;
                max-width: 100%;
                padding-bottom: 63vw;
              }

              .mini {
                display: block;
              }

              .not-mini {
                display: none;
              }

              .step-img {
                position: absolute;
                bottom: -3rem;
                left: calc(-8.2rem - 4.8rem - 7.2rem);
                width: 100vw;
                max-width: 100vw;
                height: calc(100% + 8rem);
                margin: 0;
                object-fit: cover;
                object-position: bottom center;
              }
            }
          }
        }

        @media screen and (max-width: 700px) {
          .inner-step {
            overflow: hidden;

            .step-content {
              .step-img {
                left: calc(-2.1rem - 2.4rem - 4.6rem);
              }
            }
          }
        }
      }
    }

    .cta {
      padding: 10rem 3rem;
      text-align: center;

      h2 {
        max-width: 93rem;
        margin: 0 auto 5rem;
      }

      @media screen and (max-width: 700px) {
        padding: 5rem 3rem;

        h2 {
          font-size: 2rem;
          line-height: 1.3;
          letter-spacing: 0.2rem;
        }
      }
    }
  }
}

.header-section {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 90vh;
  max-height: 77rem;

  .background-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    object-fit: cover;
    object-position: top;
  }

  .layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($black, 0.44);
  }

  h2 {
    z-index: 1;
    color: $white;
    font-family: 'SST Condensed';
    font-size: 8rem;
    line-height: 8rem;
    letter-spacing: 1.6rem;
    text-align: center;
    text-transform: uppercase;
  }

  .subtitle {
    z-index: 1;
    max-width: 37.4rem;
    margin-top: 1.6rem;
    color: $white;
    font-size: 1.6rem;
    line-height: 1.3;
    text-align: center;

    @media screen and (min-width: 1023px) {
      max-width: 700px;
    }
  }
}

@media screen and (max-width: 700px) {
  .header-section {
    h2 {
      font-size: 6.1rem;
      line-height: 6.4rem;
      letter-spacing: 1rem;
    }

    .subtitle {
      max-width: calc(100% - 5rem);

      &.large {
        max-width: calc(100% - 5rem);
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .header-section {
    h2 {
      font-size: 4.1rem;
      line-height: 4.4rem;
      letter-spacing: 0.8rem;
    }
  }
}
</style>
